import * as SwitchPrimitives from "@radix-ui/react-switch"
import { cn } from "@/lib/utils"

type SwitchProps = React.ComponentPropsWithRef<typeof SwitchPrimitives.Root> & {
  label?: string
  assistiveText?: string
}
export const Switch = ({ className, id, label, assistiveText, ...props }: SwitchProps) => (
  <div className="inline-flex space-x-4">
    <SwitchPrimitives.Root
      className={cn(
        "data-[state=checked]:bg-primary data-[state=unchecked]:bg-surface-subdued focus-visible:outline-primary data-[state=checked]:hover:enabled:bg-primary-hovered data-[state=unchecked]:hover:enabled:bg-surface-subdued-hovered data-[state=checked]:active:enabled:bg-primary-pressed data-[state=unchecked]:active:enabled:bg-surface-subdued-pressed disabled:bg-surface-disabled! relative inline-flex h-8 w-13 cursor-pointer items-center rounded-full border-none transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed",
        className,
      )}
      {...props}
      id={id}>
      <SwitchPrimitives.Thumb
        className={cn(
          "bg-background block h-6 w-6 rounded-full shadow-lg ring-0 transition-transform disabled:cursor-not-allowed data-[state=checked]:translate-x-6 data-[state=unchecked]:translate-x-1",
        )}
      />
    </SwitchPrimitives.Root>
    {label && (
      <label htmlFor={id} className="pt-1.5">
        <p className="leading-tight">{label}</p>
        {assistiveText && <span className="text-on-surface-subdued text-sm leading-tight">{assistiveText}</span>}
      </label>
    )}
  </div>
)
